import { render } from "./ModalPopupForm.vue?vue&type=template&id=397d22fc&scoped=true"
import script from "./ModalPopupForm.vue?vue&type=script&lang=js"
export * from "./ModalPopupForm.vue?vue&type=script&lang=js"

import "./ModalPopupForm.vue?vue&type=style&index=0&id=397d22fc&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397d22fc"]])

export default __exports__